import React from "react";
import CommonLayout from "../../components/Layouts/CommonLayout";
import GiftCards from "../../components/GiftCards";

const GiftCardsPage = () => {
  return <GiftCards />;
};

export default GiftCardsPage;
